import { gql } from "@apollo/client";

export const getCategories = gql`
  query GetCategories($path: String!) {
    pages {
      treeAsCategories(
        locale: "pt-br"
        mode: ALL
        path: $path
        isPublished: true
      ) {
        id
        path
        title
        depth
        isFolder
        parent
        pageId
      }
    }
  }
`;
